<template>
  <v-layout row justify-center>
    <v-dialog v-model="showNewEvaluation" max-width="90%"
      transition="dialog-bottom-transition" @keydown.esc="showNewEvaluation = false">
      <v-card>
        <v-toolbar color="blue-grey lighten-5">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">Nova avaliação</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="showNewEvaluation = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <evaluation-item :evaluation="evaluation"></evaluation-item>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import EventBus from '@/event-bus'
import UserEvaluationsItem from '@/components/user/evaluations/UserEvaluationsItem'

export default {
  data: () => ({
    showNewEvaluation: false,
    loadingRequest: false,
    evaluation: {
      skinfolds: {
        triceps: { first: '', second: '', third: '' },
        biceps: { first: '', second: '', third: '' },
        subscapular: { first: '', second: '', third: '' },
        chest: { first: '', second: '', third: '' },
        armpit: { first: '', second: '', third: '' },
        iliac: { first: '', second: '', third: '' },
        supraspinatus: { first: '', second: '', third: '' },
        abdominal: { first: '', second: '', third: '' },
        thigh: { first: '', second: '', third: '' },
        calf: { first: '', second: '', third: '' }
      }
    }
  }),

  methods: {

  },

  beforeDestroy () {
    EventBus.$off('showNewEvaluation')
  },

  mounted () {
    EventBus.$on('showNewEvaluation', data => {
      this.showNewEvaluation = data

      EventBus.$emit('evaluationCurrentStep', 1)
      EventBus.$emit('loadUserEvaluations')
    })
  },

  components: {
    'evaluation-item': UserEvaluationsItem
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/evaluations/UserNewEvaluation.vue